import React, { ReactNode } from 'react';
import { Grid, Typography } from "@mui/material";

interface NoMatchingInvoicesFoundProps {
  item?: boolean;
  imageURI?: string;
  message?: ReactNode;
}

const NoMatchingInvoicesFound: React.FC<NoMatchingInvoicesFoundProps> = ({
  item = false,
  imageURI = "/app-images/person-and-box.svg",
  message = "No matching invoices found"
}) => {
  return (
    <Grid item={item} container spacing={4}>
      <Grid item xs={12} textAlign={'center'}>
        <img src={imageURI} alt="No matching invoices found" />
      </Grid>
      <Grid item xs={12} textAlign={'center'}>
        {
          message && React.isValidElement(message)
            ? message
            : <Typography variant='body2'>{message}</Typography>
        }
      </Grid>
    </Grid>
  );
};

export default NoMatchingInvoicesFound;